import { render, staticRenderFns } from "./LocalOcorrenciaSugestao.vue?vue&type=template&id=d4800c7a&scoped=true&"
import script from "./LocalOcorrenciaSugestao.vue?vue&type=script&lang=js&"
export * from "./LocalOcorrenciaSugestao.vue?vue&type=script&lang=js&"
import style0 from "./LocalOcorrenciaSugestao.vue?vue&type=style&index=0&id=d4800c7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4800c7a",
  null
  
)

export default component.exports